import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white text-center py-4">
      <p>&copy; 2024 Udayraj Jhala. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
